<template>
  <div class="float-box" v-if="isTop">
    <div class="return-top" @click="toTop"></div>
  </div>
</template>
<script>
export default {
  name: 'scroll',
  data () {
    return {
      isTop: false
    }
  },
  mounted () {
    window.addEventListener("scroll",this.handScroll);
  },
  methods: {
    // 距顶部距离
    handScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let scrollHeight = document.body.clientWidth
      if (scrollTop+200>scrollHeight){
        this.isTop = true
      } else {
        this.isTop = false
      }
    },
    // 返回顶部
    toTop () {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          this.isTop = false
          clearInterval(timeTop)
        }
      }, 10)
    },
  }
}
</script>
<style scoped>
.float-box{
  position:fixed;
  bottom:1.28rem;
  right:.3rem;
  width:.97rem;
  height:.97rem;
}
.return-top{
  width:1.18rem;
  height:1.18rem;
  background-size:100%;
  margin-top:-.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/scroll.vue